const rca = {
  // General
  "rca-title": "RCA(Root Cause Analysis)",

  // Fitting
  "rca-fitting-button": "Fitting",
  "rca-fitting-in-progress": "Fitting...",
  "rca-load-gcm-button": "Load Existing Model",
  "rca-gcm-model-name": "Model Name",
  "rca-load-gcm-modal-title": "Model List",
  "rca-load-gcm-no-models": "No models available",
  "rca-load-gcm-select": "Select",

  // Right panel
  "rca-outcome-change": "Outcome Change",
  "rca-advanced-mode": "Advanced mode",
  "rca-anomaly-attribution": "Anomaly Attribution",
  "rca-distribution-change-attribution": "Distribution Change Attribution",
  "rca-parent-relevance": "Parent Relevance",
  "rca-upstream-influence": "Upstream Influence",

  // Node tooltip
  "rca-node-name": "Node Name",
  "rca-mechanism": "Mechanism",
  "rca-parent-nodes": "Parent Nodes",
  "rca-root-node": "None (Root Node)",
  "rca-mse": "MSE",
  "rca-r2": "R²",
  "rca-selected-node": "Selected Node",
  "rca-pending-operation": "Analysis to Execute",
  "rca-no-node-selected": "Select a node",
  "rca-apply-button": "Apply",
  "rca-cancel-button": "← Back",

  // Anomaly Attribution
  "rca-anomaly-threshold-title": "Anomaly Threshold",
  "rca-anomaly-histogram-title": "Anomaly Distribution",
  "rca-anomaly-setting": "Anomaly Setting",
  "rca-anomaly-threshold": "Threshold",
  "rca-lower-threshold": "Lower Anomaly",
  "rca-upper-threshold": "Upper Anomaly",
  "rca-anomaly-upper-calculate": "Calculate with Upper Threshold",
  "rca-anomaly-lower-calculate": "Calculate with Lower Threshold",
  "rca-threshold-confirm-button": "Confirm",
  "rca-calculate-button": "Calculate",
  "rca-result-table-title": "Results",
  "rca-result-variable": "Variable",
  "rca-result-anomaly-score": "Anomaly Score (σ)",
  "rca-result-pct": "Share (%)",
  "rca-result-graph-pct": "Graph %",
  "rca-result-explained-portion": "Proportion explained by upstream variables",
  "rca-no-anomaly-values": "There are no abnormal values exceeding this threshold.",

  // Upstream influence
  "rca-upstream-influence-value": "Standard Deviation",
  "rca-upstream-no-result": "No results available",

  // Distribution change attribution
  "rca-distribution-context-title": "Select context",
  "rca-distribution-trend-title": "Trend",
  "rca-distribution-freq-daily": "Daily",
  "rca-distribution-freq-weekly": "Weekly",
  "rca-distribution-freq-monthly": "Monthly",
  "rca-distribution-period-label": "Period",
  "rca-distribution-divergence-label": "Distribution divergence",
  "rca-distribution-divergence-hint": "0: identical / 1: no overlap",
  "rca-distribution-selected": "Selected",
  "rca-distribution-background": "Background",
  "rca-distribution-undrawable": "Cannot draw the distribution (only one data point, or all values are identical). Please change the period.",
  "rca-distribution-no-result": "No results available",
  "rca-result-divergence-score": "Divergence attribution",
};

export default rca;
